module.exports = __webpack_public_path__ + "img/banner.d1909d50.jpg";